export enum ReferralsourceFilterOptions {
    None = 1,
    Deleted = 2
}
